"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformObjectActionEventForSegment = exports.transformEventForSegment = void 0;
const types_1 = require("../../../types");
function transformEventForSegment(event, transformLegacyEventForSegment) {
    if ('type' in event) {
        switch (event.type) {
            case 'test':
                return null;
            case 'legacy':
                return transformLegacyEventForSegment(event.data);
            default: {
                const _exhaustive = event;
                return _exhaustive;
            }
        }
    }
    return transformObjectActionEventForSegment(event);
}
exports.transformEventForSegment = transformEventForSegment;
function transformObjectActionEventForSegment(event) {
    if (!(0, types_1.isBaseObjectActionEvent)(event)) {
        throw new Error('Invalid event');
    }
    const { object, action, properties } = event;
    return {
        method: 'track',
        parameters: [`${object} ${action}`, properties],
    };
}
exports.transformObjectActionEventForSegment = transformObjectActionEventForSegment;
//# sourceMappingURL=index.js.map